export default __webpack_public_path__ + "static/media/kpi-screens.520ef7a9.svg";